import { render, staticRenderFns } from "./DerbyPlayer.vue?vue&type=template&id=5f908338&scoped=true&"
import script from "./DerbyPlayer.vue?vue&type=script&lang=js&"
export * from "./DerbyPlayer.vue?vue&type=script&lang=js&"
import style0 from "./DerbyPlayer.vue?vue&type=style&index=0&id=5f908338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f908338",
  null
  
)

export default component.exports